module.exports = __webpack_public_path__ + "static/img_19-834dcf61ae0d9527872e99204df8c586.png";